(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../../../enums/metrics.js').dataType,
            require('../../../enums/metrics.js').collection,
            require('../../../enums/metrics.js').sources,
            require('../../../enums/metrics.js').sourceDetails,
            require('../enums/dataSourceFilterGroupIds.js')
        );

    } else {
        RivalIQ.module('metrics.new.dataSources', function (dataSources) {
            dataSources.CrossChannelPublicPost = exportFn(
                RivalIQ.enums.dataType,
                RivalIQ.enums.collection,
                RivalIQ.enums.sources,
                RivalIQ.enums.sourceDetails,
                RivalIQ.metrics.new.enums.DataSourceFilterGroupIds
            );
        });
    }

    function exportFn(dataType, collection, sources, sourceDetails, DataSourceFilterGroupIds) {
        return {
            name: 'Cross-channel public post data',
            channelName: sourceDetails[sources.CROSS_CHANNEL].name,
            postName: sourceDetails[sources.CROSS_CHANNEL].postName,

            storageDimensions: [
                'postId'
            ],

            availableDimensions: [
                'companyId',
                'companySetId',
                'day', 'week', 'month',
                'dayOfWeek', 'hourOfDay',
                'mediaType',
                'engagementType',
                'reactionType',
                'postTagId',
                'source',
                'hashtag',
                'keyword'
            ],

            fields: {
                postId: {
                    dataType: dataType.STRING
                },
                native_id: {
                    dataType: dataType.STRING
                },
                companyId: {
                    dataType: dataType.STRING
                },
                published_at: {
                    name: 'Published At',
                    dataType: dataType.DATE
                },
                engagement_total: {
                    name: 'Engagement Total',
                    collection: collection.ENGAGEMENT,
                    dataType: dataType.INTEGER
                },
                applause: {
                    name: 'Applause',
                    collection: collection.ENGAGEMENT_DETAILS,
                    dataType: dataType.INTEGER
                },
                amplification: {
                    name: 'Amplification',
                    collection: collection.ENGAGEMENT_DETAILS,
                    dataType: dataType.INTEGER
                },
                conversation: {
                    name: 'Conversation',
                    collection: collection.ENGAGEMENT_DETAILS,
                    dataType: dataType.INTEGER
                },
                presence_reach: {
                    name: 'Audience',
                    collection: collection.AUDIENCE,
                    dataType: dataType.INTEGER
                },
                engagement_rate_by_presence_reach: {
                    name: 'Engagement Rate by Follower',
                    collection: collection.ENGAGEMENT,
                    dataType: dataType.NUMERIC
                },
                has_hashtags: {
                    // 1 if this post has any hashtags, 0 otherwise.
                    dataType: dataType.INTEGER
                },
                engagement_rate_by_presence_reach_lift: {
                    name: 'Engagement Rate Lift',
                    collection: collection.ENGAGEMENT,
                    dataType: dataType.NUMERIC
                },
                other_posts_engagement_rate_by_presence_reach: {
                    name: 'Engagement Rate by Follower w/o tag',
                    collection: collection.ENGAGEMENT,
                    dataType: dataType.NUMERIC
                },
                message: {
                    name: 'Message',
                    dataType: dataType.STRING
                },
                postLink: {
                    name: 'Post Link',
                    dataType: dataType.STRING
                },
                mediaType: {
                    name: 'Type',
                    dataType: dataType.STRING
                },
                link: {
                    name: 'Link',
                    dataType: dataType.STRING
                },
                canonicalUrl: {
                    name: 'Posted URL',
                    dataType: dataType.STRING
                },
                linkTitle: {
                    name: 'Link Title',
                    dataType: dataType.STRING
                },
                postedTitle: {
                    name: 'Posted Title',
                    dataType: dataType.STRING
                },
                captured_at: {
                    name: 'Captured At',
                    dataType: dataType.DATE
                },
                platformImageUrl: {
                    dataType: dataType.STRING
                },
                imageUrl: {
                    dataType: dataType.STRING
                },
                linkDescription: {
                    name: 'Link Description',
                    dataType: dataType.STRING
                },
                presence_handle: {
                    name: 'Presence Handle',
                    dataType: dataType.STRING
                },
                source: {
                    dataType: dataType.INTEGER
                },
                video_views: {
                    name: 'Video Views',
                    dataType: dataType.TOTAL,
                    collection: collection.VIDEO_VIEWS_DETAILS
                },
                video_views_per_post: {
                    name: 'Video Views / Post',
                    dataType: dataType.NUMERIC,
                    collection: collection.VIDEO_VIEWS_DETAILS
                },
                engagement_rate_by_view: {
                    name: 'Engagement Rate by View',
                    collection: collection.ENGAGEMENT,
                    dataType: dataType.NUMERIC
                },
                impressions: {
                    name: 'Impressions',
                    collection: collection.GENERAL,
                    dataType: dataType.NUMERIC
                },
                estimated_impressions: {
                    name: 'Estimated Impressions',
                    collection: collection.GENERAL,
                    dataType: dataType.NUMERIC
                },
                engagement_rate_by_estimated_impression: {
                    name: 'Engagement Rate by Estimated Impression',
                    collection: collection.GENERAL,
                    dataType: dataType.NUMERIC
                }
            },

            supportedFilterGroups: [
                DataSourceFilterGroupIds.company,
                DataSourceFilterGroupIds.timePeriod,
                DataSourceFilterGroupIds.source,
                DataSourceFilterGroupIds.publicPost,
                DataSourceFilterGroupIds.ordering
            ]
        };
    }
})();
